import _set from 'lodash.set';

function set(obj, path, value) {
    return _set(obj, path, value);
}

export { set };
